import { createContext, useContext, useEffect, useState } from "react";
import api, { apiError } from "./api";

const AuthCtx = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setAdmin(r.data))
      .catch(() => setAdmin(false));
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("lok_access_token", data.access_token);
      setAdmin(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiError(e) };
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("lok_access_token");
    setAdmin(false);
  };

  return <AuthCtx.Provider value={{ admin, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAdminAuth = () => useContext(AuthCtx);
